// extracted by mini-css-extract-plugin
module.exports = {"toggleIconButton":"ToggleIconButton_toggleIconButton__gpEQX","active":"ToggleIconButton_active__5M_sC"};